import DOMPurify from "dompurify";

const Alert = (props) => {
  const { title, message, type, closeAlert } = props;

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function alertType() {
    switch (type) {
      case "error":
        return "danger";
      case "notice":
        return "info";
      case "success":
        return "success";
      case "warning":
        return "warning";
      default:
        return type;
    }
  }

  return (
    <div
      className={`alert alert-dismissible ps-4 pe-4 mt-3 mb-4 alert-${alertType()}`}
    >
      <div
        style={{ fontWeight: "bold" }}
        className="mb-1"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            title ? title : `${capitalizeFirstLetter(type)}!`
          ),
        }}
      />
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
      {closeAlert !== undefined && closeAlert !== null && (
        <div className="d-flex">
          <button
            style={{ alignSelf: "anchor-center" }}
            type="button"
            id="alert-button-close"
            className="btn-close"
            onClick={closeAlert}
          ></button>
        </div>
      )}
    </div>
  );
};

export default Alert;
